package fr.frux.core.common.result

import kotlin.coroutines.cancellation.CancellationException

/**
 * Comme [runCatching] : capture **tous** les [Throwable], pas seulement les [Exception].
 *
 * Indispensable côté wasmJs/js, où les erreurs du moteur Ktor (`io.ktor.client.engine.js.JsError`)
 * dérivent directement de [Throwable] — un `catch (e: Exception)` ne les attrape pas et le réseau
 * indisponible fait alors remonter l'erreur jusqu'à la coroutine appelante (#121).
 *
 * Contrairement à [runCatching], relance [CancellationException] : avaler une annulation casserait
 * la coopération structurée des coroutines.
 */
inline fun <T> runCatchingCancellable(block: () -> T): Result<T> {
    return try {
        Result.success(block())
    } catch (e: CancellationException) {
        throw e
    } catch (e: Throwable) {
        Result.failure(e)
    }
}
